import uploadIcon from '@/public/images/icons/upload--white.svg';
import { useUploadNewButton } from './useUploadNewButton';
import { UploaderLabel } from '../UploaderLabel';

type UploadNewLabelProps = {
  uploaderId: string;
};

export function UploadNewButton({ uploaderId }: UploadNewLabelProps) {
  const { onClick, text } = useUploadNewButton();
  return (
    <UploaderLabel
      className="M18 flex items-center space-s-3 flex-shrink-0"
      forId={uploaderId}
      onClick={onClick}
    >
      <span>{text}</span>
      <div className="rounded-lg p-2 bg-primary-accent bg-overlay-white-10">
        <img {...uploadIcon} alt="" />
      </div>
    </UploaderLabel>
  );
}
